<script>
import { mapActions } from 'vuex';
import TableView from '@/components/elements/views/TableView';

export default {
    page: {
        title: 'Ads'
    },

    extends: TableView,

    data() {
        const {
            params: { id: adPositionId }
        } = this.$route;

        return {
            adPosition: {},
            adPositionId,
            pageTitle: 'Ads',
            actions: []
        };
    },

    computed: {
        labels() {
            return [
                { value: 'name', width: '150px' },
                { value: 'views', width: '150px' },
                { value: 'clicks', width: '150px' },
                { value: 'exposure', width: '150px' },
                { value: 'createdAt', width: '150px', filter: 'formatDate' }
            ];
        },

        breadcrumbs() {
            return [
                {
                    text: 'Aguda',
                    to: '/'
                },
                {
                    text: 'Ad Positions',
                    to: '/ad-positions'
                },
                {
                    text: this.adPosition.name
                },
                {
                    text: 'Ads',
                    active: true
                }
            ];
        },

        additionalFetchData() {
            return {
                id: this.adPositionId
            };
        }
    },

    async mounted() {
        const adPosition = await this.getAdPosition(this.adPositionId);

        this.adPosition = adPosition;
    },

    methods: {
        ...mapActions({
            deleteItem: 'ads/destroy',
            getItems: 'adPositions/getAds',
            getAdPosition: 'adPositions/show'
        }),

        onAddButtonClick() {
            this.$router.push(`/ads/add?adPositionId=${this.adPositionId}`);
        },

        onRowClick({ id }) {
            this.$router.push(`/ads/${id}/edit`);
        }
    }
};
</script>
